module.exports = __webpack_public_path__ + "static/media/clock2x.ae2c8a4f.png";